var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-header",class:{ 'm-0': _vm.card || _vm.list }},[_c('h1',{staticClass:"category-header__title",class:{
      'm-0 category-header__title--card': _vm.card,
      'category-header__title--list': _vm.list,
    }},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.withActions)?_c('div',{staticClass:"action-block",class:_vm.actionsClass},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }